module.exports = __webpack_public_path__ + "static/media/codec.d8f69bd8.ogg";